<script lang="ts" context="module">
  let videoElement: HTMLVideoElement;
  export function setVideoTime(time: number) {
    videoElement.currentTime = time;
  }
  export function playVideo() {
    if (!videoElement.paused) return false;
    videoElement.play();
  }
</script>

<script lang="ts">
  import {project, subtitles} from '@/store';
  import {VideoControls} from '@components';
  import type {Video} from '@/types/project';
  import {afterUpdate, createEventDispatcher, onDestroy, onMount} from 'svelte';
  import {toTime} from '@/utils/common';

  export let play: boolean = false;
  export let currentTime: number = 0;

  let currentProgress = 0;
  let progressBar: any;
  let selectedVideo: Video | null = null;

  const dispatch = createEventDispatcher();
  $: if (play) {
    playVideo();
    play = false;
  }
  const subscription = project.subscribe(p => {
    selectedVideo = p.video;
  });
  onMount(() => {});

  onDestroy(subscription);

  // afterUpdate(() => {
  //   videoElement.currentTime = currentTime;
  //   updateProgressBar();
  // });

  let videoLoaded = false;
  let videoPlayPromise: Promise<void> | null = null;

  const playVideo = () => {
    if (!videoLoaded) return console.log('video not yet loaded');

    if (!videoElement.paused) return videoElement.pause();
    return (videoPlayPromise = videoElement.play());
  };

  const pauseVideo = () => {
    if (!videoLoaded) return console.log('video not yet loaded');

    if (videoElement.paused) return;
    if (videoPlayPromise) return videoPlayPromise.then(() => videoElement.pause());
    videoElement.pause();
  };

  const stopVideo = () => {
    videoElement.load();
    currentTime = 0;
    updateProgressBar();
  };

  const seekTimeline = (e: any) => {
    const {value} = e.detail;
    const derived = value / 100;

    videoElement.currentTime = videoElement.duration * derived;
    dispatch('video-seek', {time: videoElement.currentTime});
  };

  $: (() => {
    if (currentTime && videoElement) {
      videoElement.currentTime = currentTime;
      updateProgressBar();
    }
  })();

  const updateProgressBar = () => {
    let bar = progressBar.getProgressElement();
    bar.value = videoElement.currentTime === 0 ? 0 : (videoElement.currentTime / videoElement.duration) * 100;
    progressBar.changeRunnerColor(bar);
    return bar.value;
  };

  const progressLoop = () => {
    currentProgress = updateProgressBar();
  };

  const setVideoLoaded = (event: Event) => (videoLoaded = true);

  onMount(() => {
    videoElement.addEventListener('loadedmetadata', setVideoLoaded);
  });

  onDestroy(() => {
    videoElement.removeEventListener('loadedmetadata', setVideoLoaded);
  });
</script>

<div class="flex h-full w-full flex-grow justify-center overflow-hidden !pt-6">
  <div class="flex w-full flex-col items-center justify-center">
    <div class="flex aspect-video max-w-full px-5">
      <video
        class="h-full w-full rounded-lg"
        controls={false}
        id="videoElement"
        bind:this={videoElement}
        on:ended={stopVideo}
        on:timeupdate={() => progressLoop()}
      >
        <source src={selectedVideo?.url} type="video/mp4" />
        <track kind="captions" />
      </video>
    </div>
    <div class="absolute bottom-0 w-full">
      <VideoControls
        bind:progressBar
        showDuration={true}
        on:stop-video={stopVideo}
        on:play-video={playVideo}
        on:pause-video={pauseVideo}
        on:seek-timeline={seekTimeline}
        progress={currentProgress}
        duration={selectedVideo?.metadata?.duration}
      />
    </div>
  </div>
</div>

<style lang="postcss">
</style>
